var _path, _rect, _path2, _rect2, _rect3, _circle, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEdgeComputing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.14941,51.25a.7502.7502,0,0,0-.75.75V70a.7502.7502,0,0,0,.75.75H70a.7502.7502,0,0,0,.75-.75V52a.7502.7502,0,0,0-.75-.75H64.75V46a.7502.7502,0,0,0-.75-.75H40.75v-4.5H50a.7502.7502,0,0,0,.75-.75V24a.7502.7502,0,0,0-.75-.75H30a.7502.7502,0,0,0-.75.75V40a.7502.7502,0,0,0,.75.75h9.25v4.5H16a.7502.7502,0,0,0-.75.75v5.25H12.22363a.7502.7502,0,0,0-.75.75V66a.7502.7502,0,0,0,.75.75H20a.7502.7502,0,0,0,.75-.75V52a.7502.7502,0,0,0-.75-.75H16.75v-4.5h22.5v2.5H28a.7502.7502,0,0,0-.75.75V65.6665a.75019.75019,0,0,0,.75.75H52a.75019.75019,0,0,0,.75-.75V50a.7502.7502,0,0,0-.75-.75H40.75v-2.5h22.5v4.5ZM19.25,52.75v12.5H12.97363V52.75Zm11.5-28h18.5v6.5H30.75Zm20.5,26V64.9165H28.75V50.75Zm-20.5-11.5v-6.5h18.5v6.5Zm38.5,13.5v16.5H58.89941V52.75Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 69.25,
    width: 28,
    height: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.957,30.71631q.3501.03369.71.03369v-1.5c-.1914,0-.38086-.00928-.56738-.02686a5.91626,5.91626,0,1,1,3.13574-11.21289.74908.74908,0,0,0,1.03125-.41992,10.35182,10.35182,0,0,1,20.04492,2.54785.75052.75052,0,0,0,1.207.523,4.74342,4.74342,0,0,1,2.92579-1.02246,4.80567,4.80567,0,0,1,0,9.61133h-.58106v1.5h.58106a6.30567,6.30567,0,0,0,0-12.61133,6.14621,6.14621,0,0,0-2.80762.67676,11.85329,11.85329,0,0,0-22.48828-2.4668A7.30371,7.30371,0,0,0,26.667,15.9165a7.41693,7.41693,0,0,0-.71,14.79981Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 35.25,
    width: 8,
    height: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 27.25,
    width: 8,
    height: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 28,
    r: 1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 36,
    r: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdgeComputing);
export default __webpack_public_path__ + "static/media/icon_edge_computing.588f8212260a643455310aa65586cf91.svg";
export { ForwardRef as ReactComponent };